import $http from "@/plugins/axios.js";

export default {
  state: {
    stores: null,
    store: null,
    storeCards: null,
  },
  getters: {
    stores: (state) => state.stores,
    store: (state) => state.store,
    storeCards: (state) => state.storeCards,
  },
  mutations: {
    SET_STORES(state, data) {
      data.data.forEach((item) => {
        item.selected = false;
      });
      state.stores = data;
    },
    SET_STORE(state, data) {
      state.store = data;
    },
    SET_STORE_CARDS(state, data) {
      data.data.StoreCard.forEach((item) => {
        item.selected = false;
      });
      state.storeCards = data;
    },
  },
  actions: {
    async getStores(
      { dispatch, commit },
      payload = { take: 10, page: 1, filters: {} }
    ) {
      dispatch("toggleIsLoading", true);

      try {
        const res = await $http.get("/store/store", {
          params: {
            take: payload.take,
            page: payload.page,
            ...(payload.filters.name && { name: payload.filters.name }),
            ...(payload.filters.number && { number: payload.filters.number }),
            ...(payload.filters.tier && { tier: payload.filters.tier }),
          },
        });

        commit("SET_STORES", res.data);
      } catch (err) {
        commit("SET_STORES", null);
      } finally {
        dispatch("toggleIsLoading", false);
      }
    },

    async getCardsByStoreID(
      { dispatch, commit },
      payload = { take: 10, page: 1, filters: {} }
    ) {
      dispatch("toggleIsLoading", true);

      try {
        const res = await $http.get(`/store/storeCards/${payload.id}`, {
          params: {
            take: payload.take,
            page: payload.page,
            id: payload.filters.id,
            ...(payload.filters.type && { type: payload.filters.type }),
            ...(payload.filters.printed && {
              printed: payload.filters.printed,
            }),
            ...(payload.filters.tier && { tier: payload.filters.tier }),
          },
        });

        commit("SET_STORE_CARDS", res.data);
      } catch (err) {
        commit("SET_STORE_CARDS", null);
      } finally {
        dispatch("toggleIsLoading", false);
      }
    },

    async addStore({ dispatch, commit }, payload) {
      dispatch("toggleBtnLoading", true);
      try {
        await $http.post("/store/store", payload);
        dispatch("pushAlert", {
          alertVariant: "success",
          alertMessage: "تم اضافة البيانات بنجاح",
          duration: 3,
        });
        dispatch("toggleBtnLoading", false);
        return commit;
      } catch (err) {
        console.error(err);
        if (
          err.response.status === 500 ||
          err.response.status === 404 ||
          err.response.status === 400
        ) {
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: err.response.data.error.message,
            duration: 3,
          });
        } else {
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: "خلل في الاتصال حاول مجددا",
            duration: 3,
          });
        }
        dispatch("toggleBtnLoading", false);
        throw err;
      }
    },
    async editStore({ dispatch, commit }, payload) {
      dispatch("toggleBtnLoading", true);
      try {
        await $http.put(`/store/store/${payload.id}`, payload);
        dispatch("toggleBtnLoading", false);
        dispatch("pushAlert", {
          alertVariant: "success",
          alertMessage: "تم اضافة البيانات بنجاح",
          duration: 3,
        });
        return commit;
      } catch (err) {
        dispatch("toggleBtnLoading", false);
        if (
          err.response.status === 500 ||
          err.response.status === 404 ||
          err.response.status === 400
        ) {
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: err.response.data.error.message,
            duration: 3,
          });
        } else {
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: "خلل في الاتصال حاول مجددا",
            duration: 3,
          });
        }
        throw err;
      }
    },
    async lockStore({ dispatch, commit }, id) {
      try {
        await $http.patch(`/store/storelock/${id}`);
        dispatch("pushAlert", {
          alertVariant: "success",
          alertMessage: "تم ارسال البيانات بنجاح",
          duration: 3,
        });
        return commit;
      } catch (err) {
        if (
          err.response.status === 500 ||
          err.response.status === 404 ||
          err.response.status === 400
        ) {
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: err.response.data.error.message,
            duration: 3,
          });
        } else {
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: "خلل في الاتصال حاول مجددا",
            duration: 3,
          });
        }
        throw err;
      }
    },
    async deleteStore({ dispatch, commit }, id) {
      dispatch("toggleBtnLoading", true);
      try {
        await $http.delete(`/store/store/${id}`);
        dispatch("toggleBtnLoading", false);
        dispatch("pushAlert", {
          alertVariant: "success",
          alertMessage: "تم حذف البيانات بنجاح",
          duration: 3,
        });
        return commit;
      } catch (err) {
        console.error(err);
        if (
          err.response.status === 500 ||
          err.response.status === 404 ||
          err.response.status === 400
        ) {
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: err.response.data.error.message,
            duration: 3,
          });
        } else {
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: "خلل في الاتصال حاول مجددا",
            duration: 3,
          });
        }
        dispatch("toggleBtnLoading", false);
        return;
      }
    },
  },
};
